module.exports = __webpack_public_path__ + "static/media/cooper.497e2b54.png";